<div class="notification-content" [@EnterLeave]="currentAnimationState">
    <div class="alert alert-{{ notificationMessage.status }}" role="alert">
        <h5> {{ notificationMessage.message }} </h5>
    </div>
</div>